<se-fe-card class="docs-card">
  <se-fe-card-header
    seFeDataTitle="Feature: Unsubscribe Success "
    seFeDataSubtitle="One-click unsubscribe confirmation page"
  >
</se-fe-card-header>
  <se-fe-card-content>
    <se-po-unsubscribe-success></se-po-unsubscribe-success>
  </se-fe-card-content>
</se-fe-card>
